export default __webpack_public_path__ + "static/media/1549.0f58f3ca.png";